export default __webpack_public_path__ + "static/media/kucicaLeto.4d0f866a.svg";